export default "__VITE_ASSET__CV7zfmdJ__"